import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const HtmlEditor = styled.div`
  margin-top: 5px;
  white-space: normal;
  padding-right: 60px;
`;

export const PlainTextEditor = styled.div`
  margin-top: 5px;
  white-space: pre-wrap;
  padding-right: 60px;
`;

export const StyledNudge = styled.div`
  position: fixed;
  top: 0;
  width: 500px;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1020;
  width: 100%;
  height: 100%;
  padding: 30px 0;

  .NudgeMessagesHistory {
    background: ${colors.baseBackground};
    width: 70%;
    max-width: 1000px;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow-y: scroll;
  }
`;

export const StyledMessageComponent = styled.div`
  background-color: ${(props) => {
    if (props.direction === 'OUTBOUND') {
      return colors.lightGray7;
    }
    if (props.direction === 'INTERNAL') {
      return colors.lightGray6;
    }

    return colors.baseBackground;
  }};
  background-image: ${(props) => `url(${props.avatar})`};
  background-size: 25px;
  background-position: 22px 12px;
  background-repeat: no-repeat;
  border-bottom: 1px solid ${colors.lightGray15};
  padding: 10px 25px 10px 60px;

  .NudgeMessageTitle ._name {
    font-weight: 900;
    margin-right: 10px;
  }

  display: ${(props) => props.hideNotes && props.direction === 'INTERNAL' && 'none'};
  font-size: 14px;
  color: ${colors.baseText};
  font-family: 'Lato', sans-serif;
`;

export const HeaderDiv = styled.div`
  padding-left: 60px;
  padding-right: 25px;
  background-color: ${colors.lightGray7};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
`;

export const TitleH3 = styled.h3`
  font-size: 18px;
  font-weight: 900;
  color: ${colors.darkGray8};
  margin: 0;
`;

export const CloseButton = styled.button`
  width: 15px;
  height: 15px;
  appearance: none;
  border: none !important;
  background-color: transparent !important;
  background-image: url('/images/new-designs/close-x.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
  margin-left: 30px;
  cursor: pointer;
  filter: var(--close-icon-filter, none);
`;

export const ExpertName = styled.div`
  font-weight: 900;
  margin: 0;
  margin-right: 10px;
  cursor: pointer;
  background-color: ${(props) => props.hiddenName && colors.black1};
  font-size: 12px;
  color: ${colors.black1};
  line-height: 1;
  font-family: 'Lato', sans-serif;
`;

export const MessageHeaderDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const TextSpan = styled.span`
  margin-right: 10px;
  font-weight: ${(props) => (props.bold ? 900 : 400)};
  color: ${({ gray }) => gray && colors.darkGray14};
  display: ${({ block }) => block && 'block'};
  font-size: 12px;
`;

export const RemoveButton = styled.button`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.29px;
  color: ${colors.darkGray14};
  display: block;
  background: transparent;
  margin-left: auto;
  margin-right: 0;
  border: none;
  appearance: none;
  padding: 0;
`;

export const ConversationHeadingDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 25px 15px 60px;
  background: ${colors.selectedMessageBackground};
`;

export const SubTitleH4 = styled.h4`
  margin: 0;
  padding: 0;
  font-weight: 900;
  font-size: 12px;
  color: ${colors.lightBlack};
`;

export const ToggleButton = styled.button`
  display: block;
  appearance: none;
  border: none;
  width: 30px;
  height: 13px;
  border-radius: 6.3px;
  background-color: ${({ checked }) => (checked ? colors.simplrBlue : colors.darkGray)} !important;
  position: relative;
  outline: none;

  &::before {
    content: '';
    position: absolute;
    top: -1.5px;
    left: 0;
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    z-index: 500;
    background-color: #fff !important;
    box-shadow: 0 0 8px -2px rgba(0, 0, 0, 0.5);
    transform: ${({ checked }) => checked && 'translateX(100%)'};
    transition: linear 0.2s;
  }
`;

export const FlexRowDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
